export default {
    state: {
        generalInformation: {},
        selectedProducts: {},
        enabledApplication: {},
        supportDetails: {}
    },
    mutations: {},
    actions: {}
} 